import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  BillingHistoryItem,
  BusinessSubscription,
  PaginatedRequestResponse,
  PaymentProvider,
  RequestResponse,
  SubscriptionPlan,
} from '@/types';

export const fetchBillingHistory = async (page?: number) => {
  const response = await axiosInstance.get<
    PaginatedRequestResponse<BillingHistoryItem[]>
  >(endpoints.billingHistory, { params: { page } });
  return response.data.data;
};

export const fetchSubscriptionPlans = async (provider?: PaymentProvider) => {
  const response = await axiosInstance.get<RequestResponse<SubscriptionPlan[]>>(
    endpoints.subscriptionPlans,
    { params: { provider } }
  );
  return response.data.data;
};

export const fetchBusinessSubscription = async () => {
  const response = await axiosInstance.get<
    RequestResponse<BusinessSubscription | null>
  >(endpoints.subscriptionBusiness);
  return response.data.data;
};
